import Pristine from 'pristinejs';

export default class NewsletterForm{

	constructor(el) {

		this.el = el;
		this.tabAjaxQuery = [];
        this.initFormValidation(el);

	}

    initFormValidation(elm){

        var form = elm;
		let defaultConfig = {			
			classTo			: 'hwc-Form-field',
			errorClass		: 'has-danger',
			successClass	: 'has-success',
			errorTextParent	: 'hwc-Form-field',
			errorTextTag	: 'div',
			errorTextClass	: 'form-error-notice'
		};
        var pristine = new Pristine(form, defaultConfig);
		
		Pristine.addMessages('fr', { 
			required		: "Ce champ est requis",
            email			: "Adresse email invalide",
            number			: "Merci de renseigner un nombre",
            integer			: "Merci de renseigner un nombre entier",
            url				: "Merci de renseigner une URL",
            tel				: "Merci de renseigner un numéro de téléphone",
            maxlength		: "La longeur du champ doit être inférieure à ${1}",
            minlength		: "La longeur du champ doit être supérieure à ${1}",
            min				: "La valeur minimale est de ${1}",
            max				: "La valeur maximale est de ${1}",
            pattern			: "Merci de respecter le format attendu",
            equals			: "Les deux champs ne correspondent pas"
		}); 
		Pristine.setLocale('fr');

		var that = this;		
        form.addEventListener('submit', function (e) {

            e.preventDefault();
            
            var formIsValid = pristine.validate();
            
			if(formIsValid){				
				that.initFormAjax(form);
			}
     
         });

    }

	initFormAjax(form){
		
		this.stopAjaxQuery(this.tabAjaxQuery);

		let $ = jQuery;

		var $formElm = $(form);		
		var $notifElm = $formElm.find('.form-notif-message');
		var $notifTxtElm = $notifElm.find('.item-text');

		if($notifElm.is(':visible')){
			$notifElm.hide();
			$notifTxtElm.removeClass('is-error');
			$notifTxtElm.removeClass('is-success');
		}


		var $newsletterEmailIpt = $formElm.find('.js-newsletter-email');
		var $newsletterRgpdIpt = $formElm.find('.js-newsletter-rgpd');
		var emailValue = $newsletterEmailIpt.val();


		var ajaxDatas = {
			action      	: 'hwc_newsletter_ajax_register_email',
			email       	: emailValue,
			newsletterNonce	: hwc_vars.newsletterNonce
		};
		
		var ajaxCall = $.ajax({
			url         : hwc_vars.ajax_url,
			type        : 'POST',
			dataType    : 'JSON',
			data        : ajaxDatas,
			success     : function (tab_result) {

				if (tab_result.message) {

					$notifTxtElm.html(tab_result.message);

					if(tab_result.error){
						$notifTxtElm.addClass('is-error');
					}else{
						$notifTxtElm.addClass('is-success');
					}
										
					$newsletterEmailIpt.val('');
					$newsletterRgpdIpt.prop('checked', false);

					
					if($notifElm.is(':hidden')){
						
						$notifElm.slideDown();

					}
										
				} 

			}, 
			error       : function (errorThrown) {

				alert('AJAX ERROR');

			}
		});

		this.tabAjaxQuery.push(ajaxCall);

	}

	stopAjaxQuery(tQuery) {

        if(typeof(tQuery) == 'undefined'){
            tQuery = [];
        }

        for(var i = 0; i < tQuery.length; i++){
            tQuery[i].abort();
        }

        tQuery.length = 0;

    }

}